/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Header, Label, Icon, Button } from 'semantic-ui-react';

type Props = {
  archive: CatalogPage,
  onUnarchive: (page: CatalogPage) => void,
};

const ArchiveItem = ({ archive, onUnarchive }: Props) => {
  const unarchive = () => onUnarchive(archive);

  return (
    <Table.Row>
      <Table.Cell>
        <Header as="h3" textAlign="center">{archive.name}</Header>
      </Table.Cell>
      <Table.Cell textAlign="center">
        <Label color="green">{archive.template.label}</Label>
      </Table.Cell>
      <Table.Cell textAlign="center">
        <div className="ui tiny buttons">
          <Link
            to={`/pages/${archive.id}`}
            target="innoctopus"
            className="ui labeled icon button"
          >
            <Icon name="edit" />
            Editer
          </Link>
          <Button
            onClick={unarchive}
            color="green"
            labelPosition="right"
            content="Réactiver"
            icon="recycle"
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

export default ArchiveItem;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Archives/components/ArchiveItem.js